export const DISCOUNT = "discount"